import { configureStore } from '@reduxjs/toolkit';
import reducers from './rootReducer';

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    })
});
